/**
 * FormStepper Component
 * Multi-step form navigation with progress indicator
 */

export class FormStepper {
  constructor(containerId, steps, onStepChange) {
    this.container = document.getElementById(containerId);
    this.steps = steps;
    this.currentStep = 0;
    this.onStepChange = onStepChange;
    this.render();
  }

  render() {
    this.container.innerHTML = `
      <div class="stepper-container">
        <div class="stepper-steps">
          ${this.steps.map((step, index) => `
            <div class="stepper-step ${index === this.currentStep ? 'active' : ''} ${index < this.currentStep ? 'completed' : ''}" data-step="${index}">
              <div class="stepper-step-circle">
                ${index < this.currentStep ? '✓' : index + 1}
              </div>
              <div class="stepper-step-label">${step.label}</div>
            </div>
            ${index < this.steps.length - 1 ? '<div class="stepper-connector"></div>' : ''}
          `).join('')}
        </div>
      </div>
    `;

    // Add click handlers for completed steps (allow going back)
    this.container.querySelectorAll('.stepper-step.completed').forEach((stepEl) => {
      stepEl.addEventListener('click', () => {
        const stepIndex = parseInt(stepEl.dataset.step);
        if (stepIndex < this.currentStep) {
          this.goToStep(stepIndex);
        }
      });
    });
  }

  goToStep(stepIndex) {
    if (stepIndex < 0 || stepIndex >= this.steps.length) return;
    
    this.currentStep = stepIndex;
    this.render();
    
    if (this.onStepChange) {
      this.onStepChange(stepIndex);
    }
  }

  next() {
    if (this.currentStep < this.steps.length - 1) {
      this.goToStep(this.currentStep + 1);
    }
  }

  previous() {
    if (this.currentStep > 0) {
      this.goToStep(this.currentStep - 1);
    }
  }

  getCurrentStep() {
    return this.currentStep;
  }
}

